import antdData from 'antd/lib/locale-provider/en_US'
// https://formatjs.io/docs/react-intl/upgrade-guide-3x/#migrate-to-using-native-intl-apis
import localeData from '@formatjs/intl-pluralrules/locale-data/en'

require('@formatjs/intl-pluralrules/polyfill')
// require('@formatjs/intl-relativetimeformat/polyfill')
// require('@formatjs/intl-relativetimeformat/locale-data/en')

const messages = {
  'backend.error.validator.usernameExist': 'Username had been registered',
  'backend.error.validator.emailExist': 'Email had been registered',
  'backend.error.validator.emailRequired': 'Email is required',
  'backend.error.validator.accountNotFound': 'Account not found',
  'backend.error.validator.noValidAccountFound': 'No valid account found',
  'backend.error.validator.accountIsInactive': 'Account had not been activated yet',
  'backend.error.validator.accountIsBanned': 'Account had been banned',
  'backend.error.validator.accountHadBeenActivated': 'Account had already been activated',
  'backend.error.validator.invalidLoginCredentials': 'Invalid credentials',
  'backend.error.validator.emailUnmatched': 'Social email does not match with your account',
  'backend.error.validator.invalidOldPassword': 'Invalid old password',
  'backend.error.validator.activateTokenExpired': 'Token was expired',
  'backend.error.validator.activateTokenInvalid': 'Token is invalid',
  'backend.error.validator.notHuman': 'You are not a human being, are you?',
  'backend.error.validator.humanCheckingFailed': 'Security checking failed',
  'consent.v2.title': 'I confirm that I have read and agree to:',
  'consent.v2.required':
    'The {tos} and consent to VNG’s collection and processing of my personal data in accordance with the {privacy} for the purposes specified in Sections II.2.1, II.2.2 and II.2.3 of the {policy}.',
  'consent.v2.optional':
    'I consent to VNG’s collection and processing of my personal data in accordance with the {privacy} for the purpose specified in Section II.2.4 of the {policy}.',
  'consent.tosLink': 'Terms of Service',
  'consent.privacyLink': 'Privacy and Personal Data Protection Policy',
  'consent.policyLink': 'Policy',
  'consent.optionalTag': 'Optional',
  'consent.modal.title': 'Updated Terms and Privacy Policy',
  'consent.modal.description':
    'Code Tour has updated its Terms of Service and Privacy and Personal Data Protection Policy. Please review the content below and confirm your choices before continuing to use Code Tour.',
  'consent.modal.submit': 'Confirm and continue',
  'consent.modal.logout': 'Log out',
  'consent.success.title': 'Updated successfully!',
  'consent.success.description':
    'Thank you for confirming the Terms of Service and Privacy and Personal Data Protection Policy.',
  'consent.success.continue': 'Continue',
  'backend.error.validator.consentRequired':
    'You need to agree to the Terms of Service and Privacy Policy to continue',
  'backend.error.validator.policyVersionChanged':
    'The terms have just been updated, please review and confirm again',

  'notification.success.updateInfo': 'Information updated successfully',
  'notification.success.emailSent': 'Email sent successfully',
  'notification.success.send': 'Sent successfully',
  'notification.success.save': 'Save successfully',

  'error.notFound': 'Not found',
  'error.forbidden': 'Forbidden',

  'validator.required': 'This is a required field',
  'validator.noSpecialCharAllowed': 'No special character allowed',
  'validator.textAtLeastNLength': 'Please enter at least {N} characters',
  'validator.textMaxNLength': 'Exceeded maximum character length of {N}',
  'validator.invalidEmailFormat': 'Invalid email format',
  'validator.passwordUnmatched': 'The two passwords that you entered do not match',
  'validator.usernameOrEmailRequired': 'Please enter your username or email',
  'validator.passwordRequired': 'Please enter your password',
  'validator.passwordAtLeast1UpperCase': 'Password must contain at least one uppercase letter',
  'validator.passwordAtLeast1Number': 'Password must contain at least one number',
  'validator.passwordAtLeast1SpecialChar': 'Password must contain at least one special character',
  'validator.passwordMayNotContainSequences':
    'Password may not contain sequences of three or more repeated characters',
  'validator.mustStartWith': 'Must start with {text}',
  'validator.svgPhotoBlocked': 'SVG format photo is not allowed',
  'validator.alphabetOnly': 'Alphabet only',
  'validator.numericOnly': 'Numeric only',

  'button.save': 'Save',
  'button.cancel': 'Cancel',
  'button.edit': 'Edit',
  'button.delete': 'Delete',
  'button.joinNow': 'Join Code Tour 2026',
  'button.createTeam': 'Create team',
  'button.add': 'Add',
  'button.addMember': 'Add member',
  'button.invite': 'Invite',
  'button.getNewPassword': 'Get new password',
  'button.resend': 'Resend',
  'button.preview': 'Preview',
  'button.savePost': 'Save post',
  'button.comment': 'Comment',
  'button.viewMore': 'View more',
  'button.upload': 'Upload',
  'button.loginToComment': 'Login to comment',
  'button.goBack': 'Go back',
  'button.reply': 'Reply',
  'button.report': 'Report',
  'button.editOrDeleteThis': 'Edit or delete this',
  'button.here': 'Here',
  'button.continue': 'Continue',
  'button.back': 'Back',

  'misc.modal.confirmToDelete': 'Are you sure to delete?',
  'misc.noDataAvailable': 'No data available',
  'misc.requiredInformation': 'Required',
  'misc.here': 'here',

  'layout.header.home': 'Home',
  'layout.header.login': 'SIGN IN',
  'layout.header.logout': 'Logout',
  'layout.header.register': 'SIGN UP',
  'layout.header.register_now': 'Register now',
  'layout.header.contest': 'Contest',
  'layout.header.training': 'Practice',
  'layout.header.news': 'News',
  'layout.header.forum': 'Forum',
  'layout.header.ranking': 'Leaderboard',
  'layout.header.manage_account': 'Manage account',
  'layout.header.my_profile': 'My profile',
  'layout.header.change_password': 'Change password',
  'layout.header.manage_team': 'Manage team',

  'layout.footer.links': 'Links',
  'layout.footer.information': 'Information',
  'layout.footer.about_us': 'About Code Tour',
  'layout.footer.privacy': 'Privacy and personal data protection policy',
  'layout.footer.tos': 'Terms of service',
  'layout.footer.faq': 'FAQ',
  'layout.footer.copyright': 'Copyright © 2022',

  'layout.notification': 'Notifications',
  'layout.notification.noData': 'There is no notification',
  'layout.notification.all': 'All',
  'layout.notification.unread': 'Unread',

  'auth.signIn': 'Sign in',
  'auth.signUp': 'Sign up',
  'auth.activateSuccess': 'Account activated successfully',
  'auth.verificationRequired': 'You have not verified your account',
  'auth.verificationGuideline':
    'Please check your email and follow the instructions to verify your email and complete account registration on Code Tour.',
  'auth.verificationGuidelineResend':
    'If you have not received the email, please click {URL} to resend the email.',
  'auth.logout': 'Logout',
  'auth.email': 'Email',
  'auth.gender': 'Gender',
  'auth.gender_male': 'Male',
  'auth.gender_female': 'Female',
  'auth.gender_other': 'Other',
  'auth.username': 'Username',
  'auth.username_note':
    'Please choose a valid and professional username. The Organizing Committee may change or deactivate invalid username.',
  'auth.usernameOrEmail': 'Username/Email',
  'auth.password': 'Password',
  'auth.passwordConfirm': 'Confirm password',
  'auth.socialSignIn': 'or sign in with',
  'auth.signIn.rememberMe': 'Stay signed in',
  'auth.signIn.rememberMeHint': 'Do this to reduce the number of times you are asked to sign in',
  'auth.signIn.forgotPassword': 'Forgot password?',
  'auth.signUp.createAccount': 'Create account',
  'auth.signUp.resendEmail': 'Resend email',
  'auth.signUp.setupSocialAccount': 'Setup social account',
  'auth.signUp.agreeWith': 'I agree with',
  'auth.signUp.agreeWithTitle':
    'By registering an account on the website codetour.org, you allow VNG to use the personal information provided for the purposes of the contest in accordance.',

  'home.banner.platform': 'Platform to develop coding mindset',
  'home.banner.platformDescription':
    "A nationwide <highlight>competitive programming</highlight> contest where young tech enthusiasts <highlight>challenge</highlight> their algorithmic thinking, <highlight>sharpen</highlight> their problem-solving skills, and <highlight>connect</highlight> with Vietnam's tech community.",
  'home.banner.and': 'and',
  'home.banner.connection': 'connect tech-loving community',
  'home.banner.connection_1': 'connect passion',
  'home.banner.connection_2': 'grow',
  'home.banner.connection_3': "Vietnam's tech",
  'home.banner.connection_4': 'community',
  'home.banner.opportunity': 'unlock opportunities for tech careers',
  'home.banner.opportunity_1': 'unlock opportunities',
  'home.banner.opportunity_2': 'for tech careers',
  'home.introduction.title': 'Introduction about Code Tour',
  'home.introduction.description':
    'Launched in 2018, Code Tour began as a playground organized by VNG for young people passionate about algorithms nationwide.\nOver the years, Code Tour has evolved into a platform that cultivates programming mindset, unites the tech community, and creates career opportunities for the next generation of developers.',
  'home.fact.year': 'years of',
  'home.fact.ofDevelopment': 'growth',
  'home.fact.participant': 'participants',
  'home.fact.challenge': 'competition rounds',
  'home.fact.expert': 'experts',
  'home.glance.title': 'Code Tour 2026 at a glance',
  'home.glance.qualifierCount': '02',
  'home.glance.qualifier': 'Code Challenges',
  'home.glance.prizeCount': 'VND 100M',
  'home.glance.prize': 'total prize pool',
  'home.glance.finalistCount': 'Top 50',
  'home.glance.finalist': 'to the Final Round',
  'home.glance.ageCount': '15-24',
  'home.glance.age': 'ages',
  'home.schedule.title': 'About Code Tour 2026',
  'home.benefit.challenge': 'Sharpen your coding skills',
  'home.benefit.challengeDescription':
    'Take on expert-designed challenges and strengthen your algorithmic thinking and problem-solving skills.',
  'home.benefit.prize': 'Compete for exciting prizes',
  'home.benefit.prizeDescription':
    'Compete for a prize pool of over VND 100 million, plus exclusive gifts and rewards.',
  'home.benefit.community': 'Connect with the tech community',
  'home.benefit.communityDescription':
    'Meet, learn from, and connect with young tech enthusiasts across Vietnam.',
  'home.benefit.growth': 'Keep growing beyond the competition',
  'home.benefit.growthDescription':
    'Continue practicing on Code Tour, build your skills, and get ready for the next challenge.',
  'home.contest.title': 'Highlighted events',
  'home.testimonial.title': 'Messages from Code Tour Contestants',
  'home.partner.title': 'Accompanying partners',
  'home.partner.media': 'Media partners',
  'home.partner.organizer': 'Organizers',
  'home.partner.coOrganizer': 'Co-Organizer',
  'home.partner.partners': 'Partners',
  'home.partner.strategy': 'Strategic partners',
  'home.partner.companion': 'Accompanying partners',
  'home.partner.technical': 'Technical Partner',
  'home.partner.academic': 'Academic Partners',
  'home.profileModal.title': 'Please update your information',
  'home.profileModal.content':
    'Please provide more information in the "Manage account" section to participate in the contests',
  'home.profileModal.buttonText': 'Update now',

  'contest.searchPlaceholderPublic': 'Search for contests',
  'contest.searchPlaceholderPrivate': 'Enter secret code',
  'contest.public': 'Public',
  'contest.private': 'Private',
  'contest.status.past': 'Finished',
  'contest.status.onGoing': 'Ongoing',
  'contest.status.planned': 'Coming soon',
  'contest.pleaseEnterSecretCode':
    'Please enter the secret code provided by the Organizers to join Private Contest',
  'contest.noPrivateContestFound':
    'Your private contest is not available, please input another Secret code',
  'contest.time': 'Time',
  'contest.date': 'Date',
  'contest.begin': 'Begin',
  'contest.end': 'End',
  'contest.venue': 'Venue',
  'contest.viewDetail': 'View details',
  'contest.day': 'Days',
  'contest.day_short': 'd',
  'contest.hour': 'Hours',
  'contest.hour_short': 'h',
  'contest.minute': 'Minutes',
  'contest.minute_short': 'm',
  'contest.second': 'Seconds',
  'contest.second_short': 's',
  'contest.registeredUser': 'Participants registered',
  'contest.scoreboard': 'Leaderboard',
  'contest.button.addToCalendar': 'Calendar',
  'contest.button.addedToCalendar': 'Calendar',
  'contest.button.register': 'Register',
  'contest.button.registered': 'Registered',
  'contest.button.enterRoom': 'Enter room',
  'contest.page.information': 'Overall information',
  'contest.page.waitingRoom': 'Waiting room',
  'contest.scoreboardAnnoucement':
    'The leaderboard does not yet reflect the results of the video review. Official results will be announced on {link} Fanpage.',
  'contest.scoreboard.name': 'Name',
  'contest.scoreboard.score': 'Score',
  'contest.scoreboard.solved': 'Solved',
  'contest.scoreboard.penalty': 'Penalty',
  'contest.scoreboard.penaltyHint':
    'Total spending time which displayed as "DD:HH:mm:ss". If it is less than a day, then "DD" will be striped',
  'contest.scoreboard.firstToSolveProblem': 'First to solve problem',
  'contest.scoreboard.solvedProblem': 'Solved problem',
  'contest.scoreboard.attemptedProblem': 'Attempted problem',
  'contest.scoreboard.pendingProblem': 'Pending problem',
  'contest.scoreBoardUpdating': 'Updating',
  'contest.scoreBoardInReview': 'In review',
  'contest.scoreBoardFinalized': 'Final',
  'contest.judgementEnvironment': 'Judgement environment',
  'contest.judgementRanking': 'Judgement ranking',
  'contest.willBegin': 'The contest will begin in',
  'contest.notLoggedInToAttendContest':
    'You are not logged in. Please log in to register for the contest.',
  'contest.onlyRegisterOneContest': 'You can only register for one contest',
  'contest.notWhitelistedUser': 'You are not on the invite list for this contest',
  'contest.privateDomainRestricted': 'You are not eligible to join this private contest',
  'contest.notInWhitelistedSchool': 'This contest is only open to students from designated schools',
  'contest.registrationNotOpen': 'Registration for this contest has not opened yet',
  'contest.facebookGroupModal':
    'Follow Facebook Group "Code to Connect" to get the latest information!',
  'contest.vnoiGroupModal':
    'The contest will be on codetour.vnoi.info. Organizers will email your contest account at least 12 hours before the competition starts. Check your email to stay updated!',
  'contest.facebookGroupModalTitle': 'You have successfully registered for the contest',
  'contest.scoreBoardFilterHelper': 'Find result be school',

  'contest.unregister_modal.title': 'Confirm Unregister',
  'contest.unregister_modal.description': 'Are you sure you want to unregister from this contest?',
  'contest.unregister_modal.unregister': 'Yes, Unregister',
  'contest.unregister_modal.cancel': 'Cancel',

  'news.writeComment': 'Write a comment',
  'news.writeReplyTo': 'Reply to <username>',
  'news.filterTitle': 'News related to #',

  'forum.title': 'Title',
  'forum.searchPlaceholder': 'Search for topics',
  'forum.recentPost': 'Recent post',
  'forum.post': 'Post',
  'forum.statistic': 'Statistic',
  'forum.thread': 'Threads',
  'forum.message': 'Messages',
  'forum.createTopic': 'Create topic',
  'forum.view': 'Views',
  'forum.replies': 'Replies',
  'forum.reportContent': 'Report content',
  'forum.reportReason': 'Reason',

  'teamCard.pending': 'Waiting',
  'teamCard.leader': 'Leader',
  'teamCard.member': 'Member',
  'teamCard.addMember': 'Add Member',
  'teamCard.invite': 'Invite',
  'teamCard.inviteSuccess': 'Successfully sent invitation',
  'teamCard.myTeam': 'My teams',
  'teamCard.createTeam': 'Create teams',
  'teamCard.teamName': 'Team Name',
  'teamCard.teamDescription': 'Description',
  'teamCard.confirmDelete': 'Confirm Delete',
  'teamCard.confirmDeleteMessage': 'Are you sure to delete item?',

  'profile.information': 'INFORMATION',
  'profile.challenges': 'Challenges',
  'profile.sum': 'SUM',
  'profile.forum': 'Forum',
  'profile.UserPractice': 'UserPractices',
  'profile.resolvedAssignments': 'Resolved Assignments',

  'aboutUs.aboutCodeTourTitle': 'Introduction to Code Tour',
  'aboutUs.aboutCodeTourDescription':
    'Launched in 2018, Code Tour began as a playground organized by VNG for young people passionate about algorithms nationwide. Over the years, Code Tour has evolved into a platform that cultivates programming mindset, unites the tech community, and creates career opportunities for the next generation of developers.',
  'aboutUs.infoVisionTitle': 'Vision',
  'aboutUs.infoVisionDescription':
    'Code Tour provides a friendly platform with exciting experiences for coders to learn and connect together thereby creating a large technology community not only in Vietnam but also in Southeast Asia area and international scale.',
  'aboutUs.infoSloganTitle': 'Slogan: Code. Connect. Challenge',
  'aboutUs.infoSloganDescription':
    '<bold>Code:</bold> Sharpen your mindset and programming skills.{endline}<bold>Connect:</bold> Network and engage with the tech community.{endline}<bold>Challenge:</bold> Gain real-world experience to unlock career opportunities.',
  'aboutUs.infoMissionTitle': 'Mission: Develop tech talents',
  'aboutUs.infoMissionDescription':
    'All activities and values of Code Tour aim to create the best conditions for Codees (named members of Code Tour) to improve their mindset and develop skills through tests, exercises and networking with other Codees, helping them to nurture their passion and build their capability to develop future career.',
  'aboutUs.milestoneTitle': 'Code Tour journey',
  'aboutUs.milestoneBridgingTitle': 'Bridging',
  'aboutUs.milestoneBridgingDescription':
    'In 2025, Code Tour brought together VNG, VNU-HCM, schools, and students to connect academic learning with real-world technology. The program featured 3 Code Challenges and 1 Final Round, attracting 2,330 contestants from 80 high schools and universities in Vietnam and abroad.',
  'aboutUs.milestoneInteractionTitle': 'Interaction',
  'aboutUs.milestoneInteractionDescription':
    'In 2024, Code Tour adapted flexibly with 5 online Code Challenge rounds combined with 1 interactive webinar, where participants could hear solution walkthroughs and insights from the problem-setting committee. The contest attracted over 1,500 coders nationwide, further affirming its position as a trusted playground for young programmers.',
  'aboutUs.milestoneConnectionTitle': 'Connection',
  'aboutUs.milestoneConnectionDescription':
    'Code Tour 2023 returned with offline competitions in three cities: Hanoi, Da Nang, and Ho Chi Minh City, in collaboration with partner universities. The Grand Finale took place at VNG Campus, bringing together the most outstanding participants. The entire season saw 340 coders nationwide, fostering a vibrant atmosphere and strengthening student connections.',
  'aboutUs.milestoneExpansionTitle': 'Expansion',
  'aboutUs.milestoneExpansionDescription':
    'After a year of hiatus for platform upgrades, Code Tour 2022 came back in full force with 9 nationwide online Code Challenge rounds and 2 internal VNG rounds. The event, in partnership with the Ho Chi Minh Communist Youth Union and major universities, attracted more than 2,500 coders, setting a record for the largest scale to date.',
  'aboutUs.milestoneCollaborationTitle': 'Collaboration',
  'aboutUs.milestoneCollaborationDescription':
    'Code Tour 2020 marked a milestone by collaborating with Ho Chi Minh City University of Technology and University of Information Technology to organize dedicated rounds for students. At the same time, the special Code Tour x VTF edition was launched to connect candidates of the VNG Tech Fresher program, bringing the total number of participants in 2020 to over 1,900.',
  'aboutUs.milestoneExpandTitle': 'Expansion',
  'aboutUs.milestoneExpandDescription':
    'For the first time, Code Tour 2019 was held in both Ho Chi Minh City and Da Nang, combined with community-bonding activities at exciting new venues. Alongside, the contest featured 5 online Code Challenge rounds, raising the total number of participants that year to over 1,600.',
  'aboutUs.milestoneBeginTitle': 'Beginning',
  'aboutUs.milestoneBeginDescription':
    'The predecessor of Code Tour was Saigon Code Tour 2018 – a unique coding contest organized by VNG in Ho Chi Minh City with 4 Code Challenge rounds, attracting 182 participants. The event created a fresh and exciting academic playground for young programming enthusiasts.',

  'faq.faq': 'Frequently Asked Questions (FAQ)',

  'leaderBoard.title': 'Leaderboard',
  'leaderBoard.rank': 'Rank',
  'leaderBoard.username': 'Username',
  'leaderBoard.contest': 'Contests',
  'leaderBoard.contestHint': 'Attended Code Challenges',
  'leaderBoard.averageScore': 'Average score',
  'leaderBoard.averageScoreHint': 'Total score / Total official rounds',
  'leaderBoard.averagePenalty': 'Average penalty',
  'leaderBoard.averagePenaltyHint': 'Total penalty / Total official rounds',
  'leaderBoard.totalScore': 'Total score',
  'leaderBoard.totalScoreHint': 'Sum of scores from official rounds',
  'leaderBoard.totalPenalty': 'Total penalty',
  'leaderBoard.totalPenaltyHint': 'Sum of submission times from official rounds',
  'leaderBoard.searchPlaceholder': 'Input username or email',
  'leaderBoard.annual': 'Leaderboard by year',
  'leaderBoard.cumulative': 'Cumulative leaderboard',
  'leaderBoard.leaderBoardGuideline': 'Read criteria of Leaderboard in',
  'leaderBoard.leaderBoardCriteria': 'Criteria of Leaderboard',

  'userProfile.manageAccount': 'Manage account',
  'userProfile.from': 'From',
  'userProfile.to': 'To',
  'userProfile.present': 'Present',
  'userProfile.changeUsername': 'Change username',
  'userProfile.avatar.change': 'Change avatar',
  'userProfile.avatar.uploadedPhotos': 'Photos uploaded',

  'userProfile.information': 'Personal information',
  'userProfile.informationShort': 'Information',
  'userProfile.information.fullName': 'Full name',
  'userProfile.information.gender': 'Gender',
  'userProfile.information.gender.male': 'Male',
  'userProfile.information.gender.female': 'Female',
  'userProfile.information.gender.other': 'Other',
  'userProfile.information.birthDate': 'Year of birth',
  'userProfile.information.phone': 'Phone number',
  'userProfile.information.email': 'Email',
  'userProfile.information.country': 'Country/Region',
  'userProfile.information.province': 'Province/City',
  'userProfile.information.address': 'Address',
  'userProfile.information.certificate': 'Export your certificate',
  'userProfile.education_experience': 'Experience and education',
  'userProfile.education_experience.status': 'Current status',
  'userProfile.education_experience.student': 'Student',
  'userProfile.education_experience.worked': 'Employee',
  'userProfile.education': 'Education',
  'userProfile.education.longTitle': 'Academic level',
  'userProfile.education.school': 'School/University',
  'userProfile.education.major': 'Major',
  'userProfile.education.majorHint': 'Type N/A if you don’t have your major',
  'userProfile.education.current': 'Currently studying here',
  'userProfile.education.other': 'Other',
  'userProfile.education.otherHint': 'Type your school/university if you choose Other',
  'userProfile.education.code': 'Student code',
  'userProfile.education.codeHint': 'If you do not have one, type STUDENT',
  'userProfile.education.lock':
    'Education update feature is temporarily locked during the contest period',
  'userProfile.work': 'Experience',
  'userProfile.work.longTitle': 'Working experience',
  'userProfile.work.title': 'Role',
  'userProfile.work.company': 'Company',
  'userProfile.work.current': 'Currently working here',
  'userProfile.socialConnection': 'Connected accounts',
  'userProfile.socialConnectionShort': 'Connection',
  'userProfile.socialConnection.disconnect': 'Disconnect',
  'userProfile.changePassword': 'Change password',
  'userProfile.changePasswordSuccess': 'Password changed successfully',
  'userProfile.changePassword.oldPassword': 'Old password',
  'userProfile.changePassword.newPassword': 'New password',
  'userProfile.changePassword.newPasswordConfirm': 'Confirm password',
  'userProfile.changePassword.guideline.title': 'Follow the steps below to reset your account:',
  'userProfile.changePassword.guideline.1': 'Enter your username or email',
  'userProfile.changePassword.guideline.2':
    'Wait for the recovery information to be sent to the email address registered on Code Tour',
  'userProfile.changePassword.guideline.3': 'Follow the instructions in the email',

  'myProfile.title': 'Profile',
  'myProfile.contest.participated': 'Participated events',
  'myProfile.contest.all': 'All',
  'myProfile.contest.totalScore': 'Total points',
  'myProfile.forum.created': 'Created',
  'myProfile.forum.comment': 'Comment',
  'myProfile.forum.like': 'Liked',

  'notification.action.reply': 'replied to',
  'notification.action.post': 'posted to',
  'notification.action.like': 'reacted to',
  'notification.action.dislike': 'disliked',
  'notification.action.news': 'added',

  'notification.object.yourComment': 'your comment',
  'notification.object.yourReply': 'your reply',
  'notification.object.yourTopic': 'your topic',
  'notification.object.yourPost': 'your post',
  'notification.object.news': 'a post',

  'UserPractice.col.name': 'Name',
  'UserPractice.col.type': 'Type',
  'UserPractice.col.level': 'Level',
  'UserPractice.col.score': 'Score',
}

export default {
  locale: 'en',
  antdData,
  localeData,
  messages,
}
